<section id="SearchSection" class="search-container" [ngClass]="{'active': displaySearch}">
  <div class="input-search-container" *ngIf="displaySearch || (template == 'home' && !headerScrolled)" >
    <div class="grid grid-section" >
      <app-custom-search-input [ngClass]="{'searchbar-active':displaySearch}" [val]="textsearch" (searchChange)="onSearchChange($event)" (click)="onSearchFocus()"></app-custom-search-input>
      <button *ngIf="displaySearch" class="button button-outline-brand button-close" (click)="onCloseClick()" i18n="@@Close">
        Fermer
      </button>
    </div>
  </div>
  <div class="featured-search" *ngIf="displaySearch && textsearch == ''">
    <div class="grid grid-section most-searched-container" *ngIf="keywords">
      <div class="h3" i18n="@@MostSearched">Les plus recherchés</div>
      <div class="tags">
        <div class="tag tag-hoverable" *ngFor="let keyword of keywords" (click)="onKeywordClick(keyword)">
          {{keyword}}
        </div>
      </div>
    </div>
    <div class="featured-container" *ngIf="featured_pages">
      <div class="grid grid-section">
        <div class="h3" i18n="@@Trends">Les tendances du moment</div>
      </div>
      <div class="grid grid-section md-grid-cols-5 gap-l list-pages-container">
        <tiny-post class="col-1" *ngFor="let page of featured_pages|tinyPostsFromIds|async" [post]="page"></tiny-post>
      </div>
    </div>
  </div>
  <div class="result-search" *ngIf="displaySearch && textsearch != ''">
    <div class="grid grid-section md-grid-cols-5 gap-l results-section">
      <div class="col-span-1">
        <div class="results-navigation">
          <ul class="results-menu">
            <li [ngClass]="{'active':displayAll}" (click)="setDisplay('displayAll')">
              <span class="title" i18n="@@All">Tous</span>
              <span class="count">{{total}}</span>
            </li>
            <li [ngClass]="{'active':displaySuggestions}" (click)="setDisplay('displaySuggestions')">
              <span class="title" i18n="@@Suggestions">Suggestions</span>
              <span class="count">{{ searchResult.suggestions.length }}</span>
            </li>
            <li [ngClass]="{'active':displayActivities}" (click)="setDisplay('displayActivities')">
              <span class="title" i18n="@@Activities">Activités</span>
              <span class="count">{{ searchResult.activities.length }}</span>
            </li>
            <li [ngClass]="{'active':displayRestaurants}" (click)="setDisplay('displayRestaurants')">
              <span class="title" i18n="@@Restauration">Restauration</span>
              <span class="count">{{ searchResult.restaurants.length }}</span>
            </li>
            <li [ngClass]="{'active':displayAccommodations}" (click)="setDisplay('displayAccommodations')">
              <span class="title" i18n="@@Accomodations">Hébergements</span>
              <span class="count">{{ searchResult.accommodations.length }}</span>
            </li>
            <li [ngClass]="{'active':displayEvents}" (click)="setDisplay('displayEvents')">
              <span class="title" i18n="@@Events">Événements</span>
              <span class="count">{{ searchResult.events.length }}</span>
            </li>
            <li [ngClass]="{'active':displayStays}" (click)="setDisplay('displayStays')">
              <span class="title" i18n="@@Stays">Séjours</span>
              <span class="count">{{ searchResult.stays.length }}</span>
            </li>
            <li [ngClass]="{'active':displayServices}" (click)="setDisplay('displayServices')">
              <span class="title" i18n="@@Services">Services</span>
              <span class="count">{{ searchResult.services.length }}</span>
            </li>
            <li [ngClass]="{'active':displayOthers}" (click)="setDisplay('displayOthers')">
              <span class="title" i18n="@@Others">Autres</span>
              <span class="count">{{ searchResult.others.length }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-span-4 result-items-container">
        <div class="result-items" *ngIf="!loading && searchResult.suggestions.length>0 && (displayAll || displaySuggestions)">
          <div class="h3" i18n="@@Suggestions">Suggestions</div>
          <div class="grid p-0 md-grid-cols-4 gap-m list-pages-container">
            <tiny-post class="col-1" *ngFor="let page of searchResult.suggestions|tinyPostsFromIds:'include'|async|slice:0:(displayAll?4:999)"  [post]="page"></tiny-post>
          </div>
        </div>
        <div class="result-items" *ngIf="!loading && searchResult.all.length>0 && (displayAll)">
          <div class="h3" i18n="@@Results">Résultats</div>
          <synapi-list-items class="list-without-map list-search-results" [overflow]="true" [sort]="'ids'" [pagecountMax]="undefined" [col]="4" [ids]="searchResult.all" [size]="8" [standalone]="true"></synapi-list-items>
        </div>
        <div class="result-items" *ngIf="!loading && searchResult.activities.length>0 && (displayActivities)">
          <div class="h3" i18n="@@Activities">Activités</div>
          <synapi-list-items class="list-without-map list-search-results" [overflow]="true" [sort]="'ids'" [pagecountMax]="undefined" [col]="4" [ids]="searchResult.activities" [size]="8" [standalone]="true"></synapi-list-items>
        </div>
        <div class="result-items" *ngIf="!loading && searchResult.restaurants.length>0 && (displayRestaurants)">
          <div class="h3" i18n="@@Restauration">Restauration</div>
          <synapi-list-items class="list-without-map list-search-results" [overflow]="true" [sort]="'ids'" [pagecountMax]="undefined" [col]="4" [ids]="searchResult.restaurants"  [size]="8" [standalone]="true"></synapi-list-items>
        </div>
        <div class="result-items" *ngIf="!loading && searchResult.accommodations.length>0 && (displayAccommodations)">
          <div class="h3" i18n="@@Accomodations">Hébergements</div>
          <synapi-list-items class="list-without-map list-search-results" [overflow]="true" [sort]="'ids'" [pagecountMax]="undefined" [col]="4" [ids]="searchResult.accommodations" [size]="8" [standalone]="true"></synapi-list-items>
        </div>
        <div class="result-items" *ngIf="!loading && searchResult.events.length>0 && (displayEvents)">
          <div class="h3" i18n="@@Events">Événements</div>
          <synapi-list-items class="list-without-map list-search-results" [overflow]="true" [sort]="'ids'" [pagecountMax]="undefined" [col]="4" [ids]="searchResult.events" [size]="8" [standalone]="true"></synapi-list-items>
        </div>
        <div class="result-items" *ngIf="!loading && searchResult.stays.length>0 && (displayStays)">
          <div class="h3" i18n="@@Stays">Séjours</div>
          <synapi-list-items class="list-without-map list-search-results" [overflow]="true" [sort]="'ids'" [pagecountMax]="undefined" [col]="4" [ids]="searchResult.stays" [size]="8" [standalone]="true"></synapi-list-items>
        </div>
        <div class="result-items" *ngIf="!loading && searchResult.services.length>0 && (displayServices)">
          <div class="h3" i18n="@@Services">Services</div>
          <synapi-list-items class="list-without-map list-search-results" [overflow]="true" [sort]="'ids'" [pagecountMax]="undefined" [col]="4" [ids]="searchResult.services" [size]="8" [standalone]="true"></synapi-list-items>
        </div>
        <div class="result-items" *ngIf="!loading && searchResult.others.length>0 && (displayOthers)">
          <div class="h3" i18n="@@Others">Autres</div>
          <synapi-list-items class="list-without-map list-search-results" [overflow]="true" [sort]="'ids'" [pagecountMax]="undefined" [col]="4" [ids]="searchResult.others" [size]="8" [standalone]="true"></synapi-list-items>
        </div>
      </div>
    </div>
  </div>
</section>
